export const heroData = [
    {
        id: 1,
        title: "Ahli Pemeriksaan K3",
        subtitle: "Memberikan layanan inspeksi dan pengujian untuk memastikan keselamatan kerja optimal.",
        image: require('../images/hero/1.png')
    },
    {
        id: 2,
        title: "Keselamatan Prioritas Kami",
        subtitle: "Mendukung perusahaan Anda menciptakan tempat kerja yang aman dan sehat.",
        image: require('../images/hero/2.png')
    },
    {
        id: 3,
        title: "Layanan K3 Profesional",
        subtitle: "Solusi menyeluruh untuk pemeriksaan, pengujian, dan konsultasi di bidang K3.",
        image: require('../images/hero/3.png')
    }
]